var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"display":"none"},attrs:{"width":"0","height":"0"},domProps:{"innerHTML":_vm._s(_vm.$options.svgSprite)}})}
var staticRenderFns = []

export { render, staticRenderFns }